import {
	GET_STATIC_LANDING_PAGES_REQUEST,
	GET_STATIC_LANDING_PAGES_SUCCESS,
	GET_STATIC_LANDING_PAGES_FAILURE,
	CREATE_STATIC_LANDING_PAGE_REQUEST,
	CREATE_STATIC_LANDING_PAGE_SUCCESS,
	CREATE_STATIC_LANDING_PAGE_FAILURE,
	GET_STATIC_LANDING_PAGE_REQUEST,
	GET_STATIC_LANDING_PAGE_SUCCESS,
	GET_STATIC_LANDING_PAGE_FAILURE,
	UPDATE_STATIC_LANDING_PAGE_REQUEST,
	UPDATE_STATIC_LANDING_PAGE_SUCCESS,
	UPDATE_STATIC_LANDING_PAGE_FAILURE,
	DELETE_STATIC_LANDING_PAGE_REQUEST,
	DELETE_STATIC_LANDING_PAGE_SUCCESS,
	DELETE_STATIC_LANDING_PAGE_FAILURE,
} from '../types';
import {
	getStaticLandingPagesAPI,
	createStaticLandingPageAPI,
	getStaticLandingPageAPI,
	updateStaticLandingPageAPI,
	deleteStaticLandingPageAPI,
} from '../../services/api/staticLandingPage.api';
import { transformedStaticLandingPages } from '../../assets/js/transform/staticLandingPage';

export default {
	namespaced: true,
	state: {
		list: {
			isLoading: false,
			data: [],
			meta: {
				currentPage: 1,
				lastPage: 0,
				total: 0,
			},
		},
		edit: {
			isLoading: false,
			data: null,
		},
	},
	getters: {
		staticLandingPageList(state) {
			return transformedStaticLandingPages(state.list.data);
		},
	},
	mutations: {
		[GET_STATIC_LANDING_PAGES_REQUEST](state, { page }) {
			state.list = {
				...state.list,
				isLoading: true,
				meta: {
					...state.list.meta,
					currentPage: page,
				},
			};
		},
		[GET_STATIC_LANDING_PAGES_SUCCESS](state, { data }) {
			state.list = {
				data,
				meta: {
					currentPage: 1,
					lastPage: 1,
					total: data.length,
				},
				isLoading: false,
			};
		},
		[GET_STATIC_LANDING_PAGES_FAILURE](state) {
			state.list = {
				...state.list,
				isLoading: false,
			};
		},
		[CREATE_STATIC_LANDING_PAGE_REQUEST](state) {
			state.list = {
				...state.list,
				isLoading: true,
			};
		},
		[CREATE_STATIC_LANDING_PAGE_SUCCESS](state) {
			state.list = {
				...state.list,
				isLoading: false,
			};
		},
		[CREATE_STATIC_LANDING_PAGE_FAILURE](state) {
			state.list = {
				...state.list,
				isLoading: false,
			};
		},
		[GET_STATIC_LANDING_PAGE_REQUEST](state) {
			state.edit = {
				...state.edit,
				isLoading: true,
			};
		},
		[GET_STATIC_LANDING_PAGE_SUCCESS](state, data) {
			state.edit = {
				data,
				isLoading: false,
			};
		},
		[GET_STATIC_LANDING_PAGE_FAILURE](state) {
			state.edit = {
				...state.edit,
				isLoading: false,
			};
		},
		[UPDATE_STATIC_LANDING_PAGE_REQUEST](state) {
			state.edit = {
				...state.edit,
				isLoading: true,
			};
		},
		[UPDATE_STATIC_LANDING_PAGE_SUCCESS](state) {
			state.edit = {
				...state.edit,
				isLoading: false,
			};
		},
		[UPDATE_STATIC_LANDING_PAGE_FAILURE](state) {
			state.edit = {
				...state.edit,
				isLoading: false,
			};
		},
	},
	actions: {
		async getStaticLandingPages({ commit }, query) {
			try {
				commit(GET_STATIC_LANDING_PAGES_REQUEST, query);
				const { data } = await getStaticLandingPagesAPI(query);
				commit(GET_STATIC_LANDING_PAGES_SUCCESS, data);
			} catch (error) {
				commit(GET_STATIC_LANDING_PAGES_FAILURE);
			}
		},
		async createStaticLandingPage({ commit }, payload) {
			try {
				commit(CREATE_STATIC_LANDING_PAGE_REQUEST);
				await createStaticLandingPageAPI(payload);
				commit(CREATE_STATIC_LANDING_PAGE_SUCCESS);
			} catch (error) {
				commit(CREATE_STATIC_LANDING_PAGE_FAILURE);
				throw error;
			}
		},
		async getStaticLandingPage({ commit }, id) {
			try {
				commit(GET_STATIC_LANDING_PAGE_REQUEST);
				const { data } = await getStaticLandingPageAPI(id);
				commit(GET_STATIC_LANDING_PAGE_SUCCESS, data.data);
			} catch (error) {
				commit(GET_STATIC_LANDING_PAGE_FAILURE);
				throw error;
			}
		},
		async updateStaticLandingPage({ commit }, { id, data }) {
			try {
				commit(UPDATE_STATIC_LANDING_PAGE_REQUEST);
				await updateStaticLandingPageAPI(id, data);
				commit(UPDATE_STATIC_LANDING_PAGE_SUCCESS);
			} catch (error) {
				commit(UPDATE_STATIC_LANDING_PAGE_FAILURE);
				throw error;
			}
		},
		async deleteStaticLandingPage({ commit }, id) {
			try {
				commit(DELETE_STATIC_LANDING_PAGE_REQUEST);
				await deleteStaticLandingPageAPI(id);
				commit(DELETE_STATIC_LANDING_PAGE_SUCCESS);
			} catch (error) {
				commit(DELETE_STATIC_LANDING_PAGE_FAILURE);
				throw error;
			}
		},
	},
};
